<script setup>
import { formatDayMonthDate } from '@/lib/utils'

import { useWebSiteStore } from '@/stores/web-site.store'

import { useCurrencyColumnFormatter } from '@/composables/data-grid'

import ListItem from '@/components/shared/ListItem.vue'
import ChipTemplate from '@/components/shared/ChipTemplate.vue'

defineProps({
  row: {
    type: Object,
    required: true,
  },
  labels: {
    type: Object,
    required: true,
  },
  currencyRef: {
    type: Number,
    default: null,
  },
  includeVat: {
    type: Boolean,
    default: true,
  },
  showListingFirst: {
    type: Boolean,
    default: true,
  },
  showDate: {
    type: Boolean,
    default: true,
  },
})

const webSiteStore = useWebSiteStore()
</script>

<template>
  <list-item
    class="budget-document-row-item row-card-border q-mt-sm q-py-none"
    :style="{ padding: '.75rem', minWidth: 'initial' }"
    :right-label="row.document_row_type !== webSiteStore.documentRowTypeEnum.COMMENT ? useCurrencyColumnFormatter(row, includeVat ? 'total_vat' : 'total_no_vat', currencyRef) : ''"
    :hide-right-caption="!row.discount || row.discount === 0"
  >
    <template v-if="$slots.avatar" #avatar>
      <slot name="avatar" />
    </template>
    <template #label>
      <div style="display: inline-block; margin-right: .5rem;">
        <span style="font-weight: bolder;">{{ labels.getRowItemLabel(row) }}</span><span>{{ labels.getRowItemLabelDetail(row) }}</span>
      </div>
    </template>
    <template #caption>
      <span v-if="showListingFirst && labels.getRowItemLabelSuffix(row)" class="text-grey q-mr-xs">{{ labels.getRowItemLabelSuffix(row) }}</span>
      <span v-if="labels.getTagsChips(row).length > 0" class="q-mr-xs">
        <chip-template
          :values="labels.getTagsChips(row)"
          size="xs"
          :style="{'margin-left': '0'}"
        />
      </span>
      <span v-if="showDate && row.date" class="caption"><q-icon name="mdi-calendar" class="q-mr-xs" />{{ formatDayMonthDate(row.date) }}</span>
      <slot name="caption" />
    </template>
    <template #right-caption>
      <div v-if="row.discount && row.discount > 0" style="display: flex; align-items: center; color: red;">
        <q-icon name="mdi-label-percent" size="1rem" class="q-mr-xs" />
        <span style="font-weight: bolder;">{{ row.discount * 100 }}%</span>
      </div>
    </template>
  </list-item>
</template>

<style scoped lang="scss">
.budget-document-row-item {
  align-items: center;
}

.budget-document-row-item :deep(.q-item) {
  align-items: center;
}

.budget-document-row-item :deep(.q-item__label--caption) {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: .25rem;
  line-height: 1.3;
}

.budget-document-row-item :deep(.q-chip) {
  margin: 0;
}
</style>
